<template>
  <div class="daily_box">
    <div class="daily_box_title">
      {{ $t('mgx_daily_title') }}
    </div>
    <div class="daily_box_desc1">
      {{ $t('mgx_daily_desc1') }}
    </div>
    <div class="mgx_mode_desc">按FN+右ALT+I即可在经典输入模式和IMC模式之间切换</div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
.daily_box {
  position: relative;
  padding: 32px;
  background: var(--bg-card);
  border-radius: var(--radius-l);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  transition: var(--transition-base);

  .daily_box_title {
    font-size: 22px;
    color: var(--color-dark);
    font-weight: 800;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
  }

  .daily_box_desc1 {
    color: var(--color-dark);
    font-size: 15px;
    line-height: 1.7;
    margin-bottom: 16px;
    padding: 20px 24px;
    background: rgba(var(--color-brand-2-rgb), 0.03);
    border-radius: var(--radius-m);
    border-left: 4px solid var(--brand-color-pure);
  }

  .daily_box_desc {
    position: relative;
    padding-left: 24px;
    margin-top: 16px;
    color: var(--color-text-hint);
    font-size: 14px;
    line-height: 1.6;
    display: flex;
    align-items: flex-start;

    &::before {
      content: '•';
      position: absolute;
      left: 0;
      color: var(--brand-color-pure);
      font-size: 20px;
      line-height: 1;
    }
  }

  .mgx_mode_desc {
    margin-top: 16px;
    padding: 16px 24px;
    font-size: 13px;
    color: var(--text-secondary);
    background: rgba(0, 0, 0, 0.03);
    border-radius: var(--radius-s);
    display: inline-block;
    width: fit-content;
    font-weight: 500;
  }
}
</style>
